import React from 'react'
import SectionTitle from './SectionTitle'

interface StatWellProps {
    value: React.ReactNode
    label: string
}

// Stat well on the highlight panel: recessed darker well, big Rajdhani numeral,
// mono label. Reverts to light chrome in print.
function StatWell({value, label}: StatWellProps) {
    return (
        <div className="flex flex-col items-center gap-1.5 border border-[#363A49] bg-[#15171F] px-3 pb-3.5 pt-4 text-center shadow-[inset_0_2px_6px_rgba(0,0,0,0.35)] print:border-line print:bg-well print:shadow-none">
            <span className="font-display font-bold text-2xl md:text-[26px] leading-none text-[#EFF1F7] print:text-ink">
                {value}
            </span>
            <span className="font-mono text-[9.5px] uppercase tracking-[.18em] leading-tight text-[#C9CDD9]">
                {label}
            </span>
        </div>
    )
}

export default function About() {
    const arrow = <span className="text-accent-light">→</span>

    return (
        <section className="print-avoid-break">
            <SectionTitle title="About" index="01" />
            <div className="mt-4 font-body font-medium text-body leading-relaxed">
                <p>
                    Senior Engineering Leader and AI Solutions Architect who turns complex technical problems into shipped systems and measurable outcomes. After more than 13 years building and scaling platforms that have saved companies millions, I run <span className="font-semibold text-accent">Betabit</span>—a consultancy that owns its work end to end, from design through production.
                </p>

                <p className="mt-4">
                    I bridge strategy and execution across AI, data, and cloud—designed, built, and operated as one stack.
                </p>

                {/* TL;DR — highlight panel */}
                <div className="relative mt-7 rounded-sm border border-[#363A49] bg-[#1D1F29] px-5 pb-5 pt-7 print:border-line print:bg-white">
                    <span className="pointer-events-none absolute inset-x-0 top-0 h-[2px] bg-gradient-to-r from-primary via-accent to-accent-violet" />
                    <span className="pointer-events-none absolute -top-2 left-3.5 bg-[#1D1F29] px-2 font-display text-[11px] font-bold uppercase leading-4 tracking-[.22em] text-accent-light print:bg-white">
                        TL;DR
                    </span>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                        <StatWell value="85%" label="Led company-wide AI adoption" />
                        <StatWell value={<>Weeks {arrow} Hours</>} label="Idea to production" />
                        <StatWell value="Zero" label="Downtime across systems" />
                        <StatWell value="13+" label="Years shipping production systems" />
                        <StatWell value="100%" label={"AI-driven engineering, human‑led"} />
                        <StatWell value={<>$1.2M {arrow} $400K</>} label="Annual cloud spend, one migration" />
                    </div>
                </div>

            </div>
        </section>
    )
}
